module.exports = new __parcel__URL__("crash_8.99d0fd8d.mp3").toString();